import React from "react";
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import { useFormikContext } from "formik";
import { BasicInfo } from "app/data/terminal-details/models";


const HoursOfOperationForm = () => {

    const formikProps = useFormikContext<BasicInfo>();

    return (
        <div className="edit-flex-box">
            <XGSFormInput
                name="operationOpenHours"
                label="Operating Hours:"
                labelMode={LabelModes.column}
                readonly
                className="full-width-field"
            />
            <div className="time">
                <XGSFormInput
                    name="operationFromTime"
                    type="time"
                    className="time-picker-label "
                    placeholder=""
                    value={formikProps.values.operationFromTime || ""}
                    onChange={(e) => {
                        const fromTime = e.currentTarget.value ? e.currentTarget.value?.toUiTimeCapitalizeFormat() : "--:--"
                        const toTime = formikProps.values.operationToTime ? formikProps.values.operationToTime?.toUiTimeCapitalizeFormat() : "--:--"
                        formikProps.setFieldValue("operationOpenHours", `${'Monday-Friday'}: ${fromTime} - ${toTime}`);
                        formikProps.setFieldValue("operationFromTime", e.currentTarget.value);
                    }}
                />
                <XGSFormInput
                    name="operationToTime"
                    type="time"
                    label="To"
                    className="time-picker-label"
                    placeholder=""
                    value={formikProps.values.operationToTime || ""}
                    onChange={(e) => {
                        const fromTime = formikProps.values.operationFromTime ? formikProps.values.operationFromTime?.toUiTimeCapitalizeFormat() : "--:--"
                        const toTime = e.currentTarget.value ? e.currentTarget.value?.toUiTimeCapitalizeFormat() : "--:--"
                        formikProps.setFieldValue("operationOpenHours", `${'Monday-Friday'}: ${fromTime} - ${toTime}`);
                        formikProps.setFieldValue("operationToTime", e.currentTarget.value);
                    }}
                />
            </div>
            {/* Will Call Hours */}
            <XGSFormInput
                name="willCallOpenHours"
                label="Will Call Hours:"
                labelMode={LabelModes.column}
                readOnly
                className="full-width-field"
            />
            <div className="time">
                <XGSFormInput
                    name="willCallFromTime"
                    type="time"
                    className="time-picker-label"
                    value={formikProps.values.willCallFromTime || ""}
                    placeholder=""
                    onChange={(e) => {
                        const fromTime = e.currentTarget.value ? e.currentTarget.value?.toUiTimeCapitalizeFormat() : "--:--"
                        const toTime = formikProps.values.willCallToTime ? formikProps.values.willCallToTime?.toUiTimeCapitalizeFormat() : "--:--"
                        formikProps.setFieldValue("willCallOpenHours", `${'Monday-Friday'}: ${fromTime} - ${toTime}`);
                        formikProps.setFieldValue("willCallFromTime", e.currentTarget.value);
                    }}
                />
                <XGSFormInput
                    name="willCallToTime"
                    type="time"
                    label="To"
                    className="time-picker-label"
                    value={formikProps.values.willCallToTime || ""}
                    placeholder=""
                    onChange={(e) => {
                        const fromTime = formikProps.values.willCallFromTime ? formikProps.values.willCallFromTime?.toUiTimeCapitalizeFormat() : "--:--"
                        const toTime = e.currentTarget.value ? e.currentTarget.value?.toUiTimeCapitalizeFormat() : "--:--"
                        formikProps.setFieldValue("willCallOpenHours", `${'Monday-Friday'}: ${fromTime} - ${toTime}`);
                        formikProps.setFieldValue("willCallToTime", e.currentTarget.value);
                    }}
                />
            </div>
        </div>)
}

export default HoursOfOperationForm;
